<template>
</template>

<script>
    import Api from '../services/Api'
    import Utils from '../services/Utils'

    export default {
        beforeMount: function () {
            if (window.orderToCreate) {
                Api.createOrderVW({
                    "sourceCode": window.orderToCreate.sourceCode,
                    "amount": window.orderToCreate.amount,
                    "customerTrns": window.orderToCreate.description,
                    "customer": {
                        "email": window.orderToCreate.customerEmail,
                        "fullName": window.orderToCreate.customerName,
                        "phone": window.orderToCreate.customerPhone
                    },
                    "allowRecurring": false,
                    "tags": [
                        '{"external":true}'
                    ]
                }, (response) => {
                    if (response && response.success && response.data && response.data.order_url) {
                        window.location.href = response.data.order_url
                    } else {
                        this.$alert(
                            response.message,
                            '',
                            'warning',
                            Utils.getAlertOptions()
                        )
                    }
                })
                return
            }
            if (window.isSuccess) {
                this.$router.push({ path: '/success' })
            } else {
                this.$router.push({ path: '/failure' })
            }
        },
    }
</script>